import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';

import { IUser } from '../../models';
import { Constants } from '@config/constants';

@Injectable({ providedIn: 'root' })
export class UserService {
  public readonly API_URL = this.constants.APP_USER_ENDPOINT;
  public readonly ABS_USER_PASSWORD_ENDPOINT =
    this.constants.APP_USER_PASSWORD_ENDPOINT;

  constructor(
    private http: HttpClient,
    private readonly constants: Constants
  ) {}

  getIUsers(): Observable<IUser[]> {
    return this.http.get<IUser[]>(this.API_URL);
  }

  addIUser(user: IUser): Observable<IUser> {
    return this.http.post<IUser>(this.API_URL, user);
  }

  deleteIUser(id: number): Observable<IUser> {
    const url = `${this.API_URL}/${id}`;
    return this.http.delete<IUser>(url);
  }

  updateIUser(user: IUser): Observable<any> {
    return this.http.patch(this.API_URL, user);
  }

  generatePwd(id: number): Observable<IUser> {
    const url = `${this.ABS_USER_PASSWORD_ENDPOINT}/${id}`;
    return this.http.patch<IUser>(url, null);
  }
}
